<div class="modals--contacto relative s-regular">
  <h1 class="m-bold mt-3">{{ 'modals.contacto.title' | translate }}</h1>
  <app-cigna-icon icon="phone" class="size-32 absolute"></app-cigna-icon>
  <p>{{ 'modals.contacto.subtitle' | translate }}</p>

  @if (onTime) {
    <div class="mt-4">
      <div>{{ 'modals.contacto.llamanos' | translate }}</div>
      <div class="m-bold">
        <span innerHTML="{{ 'common.cigna_telefono1' | translate }}" class="primary-color"></span>
        /
        <span innerHTML="{{ 'common.cigna_telefono2' | translate }}" class="primary-color"></span>
        /
        <span innerHTML="{{ 'common.cigna_telefono3' | translate }}" class="primary-color"></span>
      </div>
    </div>
  }

  @if (!onTime) {
    <div class="mt-4">
      <div>{{ 'modals.contacto.horario_out' | translate }}</div>
      <div class="s-bold">{{ 'modals.contacto.horario' | translate }}</div>
      <div class="mb-2">{{ 'modals.contacto.meses' | translate }}</div>
      <div class="m-bold">
        <span class="grey-text-color">{{ 'common.cigna_telefono1_plain' | translate }}</span>
        /
        <span class="grey-text-color">{{ 'common.cigna_telefono2_plain' | translate }}</span>
        /
        <span class="grey-text-color">{{ 'common.cigna_telefono3_plain' | translate }}</span>
      </div>
    </div>
  }

  <div class="mt-4">
    <div>{{ 'modals.contacto.escribenos' | translate }}</div>
    <div innerHTML="{{ 'common.cigna_mail' | translate }}" class="m-bold primary-color"></div>
  </div>

  @if (onTime) {
    <div class="mt-4">
      <div class="xs-bold">{{ 'modals.contacto.horario' | translate }}</div>
      <div class="xs-regular">({{ 'modals.contacto.meses' | translate }})</div>
    </div>
  }
</div>
